var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-arrow-white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-white",
    clipPath: "url(#clip-arrow-white)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20950",
    "data-name": "Group 20950",
    transform: "translate(-4.094 -4.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16486",
    "data-name": "Group 16486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6448",
    "data-name": "Group 6448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18430",
    "data-name": "Path 18430",
    d: "M5.3,4.745.659.108A.386.386,0,0,0,.113.655L4.476,5.018.113,9.381a.386.386,0,0,0,.546.546L5.3,5.291A.386.386,0,0,0,5.3,4.745Z",
    transform: "translate(17.114 9.509) rotate(90)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.2b2ba6cb5def34d6e88a682e9da179c4.svg";
export { ForwardRef as ReactComponent };